import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getDataAPI } from "../../../services/apiWrapper";

/**
 * Trade -> Sub-Trade -> Course picker (LMS, faculty-scoped on the server).
 * Calls onCourse(courseId, courseObj) when the course changes (and ("", null)
 * when an earlier box is changed so the parent can clear its course state).
 */
export default function CourseCascade({ onCourse, colClass = "col-md-4" }) {
  const dispatch = useDispatch();
  const token = () => localStorage.getItem("adminToken");

  const [trades, setTrades] = useState([]);
  const [subs, setSubs] = useState([]);
  const [courses, setCourses] = useState([]);
  const [trade, setTrade] = useState("");
  const [sub, setSub] = useState("");
  const [course, setCourse] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const r = await dispatch(getDataAPI("admin/lms/content/trades", token()));
        setTrades(r.data.data || []);
      } catch (e) {
        /* non-fatal */
      }
    })();
  }, []);

  const pickTrade = (id) => {
    setTrade(id);
    setSub("");
    setCourse("");
    setCourses([]);
    const t = trades.find((x) => String(x.id) === String(id));
    setSubs(t ? t.subtrade || [] : []);
    onCourse("", null);
  };

  const pickSub = async (id) => {
    setSub(id);
    setCourse("");
    setCourses([]);
    onCourse("", null);
    if (id) {
      try {
        const r = await dispatch(getDataAPI(`admin/lms/content/subtrade-courses/${id}`, token()));
        setCourses(r.data.data || []);
      } catch (e) {
        /* non-fatal */
      }
    }
  };

  const pickCourse = (id) => {
    setCourse(id);
    const c = courses.find((x) => String(x.id) === String(id));
    onCourse(id, c || null);
  };

  return (
    <div className="row mb-3">
      <div className={colClass}>
        <label>Trade</label>
        <select className="form-control" value={trade} onChange={(e) => pickTrade(e.target.value)}>
          <option value="">— select trade —</option>
          {trades.map((t) => (
            <option key={t.id} value={t.id}>{t.name}</option>
          ))}
        </select>
      </div>
      <div className={colClass}>
        <label>Sub-Trade</label>
        <select className="form-control" value={sub} onChange={(e) => pickSub(e.target.value)} disabled={!trade}>
          <option value="">— select sub-trade —</option>
          {subs.map((s) => (
            <option key={s.id} value={s.id}>{s.name}</option>
          ))}
        </select>
      </div>
      <div className={colClass}>
        <label>Course</label>
        <select className="form-control" value={course} onChange={(e) => pickCourse(e.target.value)} disabled={!sub}>
          <option value="">— select course —</option>
          {courses.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name} {c.short_name ? `(${c.short_name})` : ""}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
